import { defineNuxtRouteMiddleware, useLayoutLoad, usePageLoad } from '#imports';

export default defineNuxtRouteMiddleware(async route => {
    if (import.meta.server) {
        await useLayoutLoad();
        await usePageLoad(route);
    }
});
